import { Injectable } from "@angular/core";

import { Observable, tap } from "rxjs";
import { IOrganization } from "../model/IOrganization";
import { BaseApiService } from "app/services/base-api.service";

@Injectable({
    providedIn: "root",
})
export class OrganizationsService extends BaseApiService<IOrganization> {
    URL: string = "/api/v1/organization";

    /**
     * Organizations the current user may switch to through X-Organization-ID
     * (organization selector): every organization for a super-admin or an
     * owner of an allowlisted organization (APPCELERATE), [] for everyone
     * else. Unlike `list()`, it ignores the organization currently
     * impersonated so the selector can always switch back.
     */
    public impersonable(): Observable<IOrganization[]> {
        return this._httpClient.get<IOrganization[]>(`${ this.URL }/impersonable`);
    }

    /**
     * Imports the organizations from the given username and password.
     *
     * @param username
     * @param password
     * @param countries
     */
    public import(username: string, password: string, countries: any): Observable<any> {
        return this._httpClient.post<IOrganization>(`${ this.URL }/import`, {username, password, countries})
            .pipe(tap((response: IOrganization) => this._item.next(response)));
    }

    /**
     * Refreshes the MediaSmart (GeoActivate) credentials stored for an organization.
     *
     * @param id Organization id
     * @param username
     * @param password
     */
    public updateCredentials(id: string, username: string, password: string): Observable<any> {
        return this._httpClient.post<IOrganization>(`${ this.URL }/${ id }/credentials`, {username, password})
            .pipe(tap((response: IOrganization) => this._item.next(response)));
    }
}
